import React from 'react';

/**
 * Full-viewport overlay — blurs entire app, centered spinner.
 */
export function GlobalLoadingOverlay({ label = 'Loading…' }) {
  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/45 backdrop-blur-lg"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <div className="flex flex-col items-center justify-center gap-5">
        <div
          className="h-16 w-16 animate-spin rounded-full border-[5px] border-white/25 border-t-white shadow-lg"
          aria-hidden
        />
        <p className="text-base font-semibold text-white drop-shadow-sm">{label}</p>
        <span className="sr-only">{label}</span>
      </div>
    </div>
  );
}
